// extracted by mini-css-extract-plugin
export var deleteModal = "_eq-0";